import { TFunction } from 'i18next'

import { InvoiceFormReceiver } from '@features/invoices/types/invoiceForm/invoiceFormReceiver'

import { DemoInvoiceCustomer } from '../types/demoInvoiceCustomer'

export const getDemoInvoiceReceiver = (
  { tName, ...customer }: DemoInvoiceCustomer,
  t: TFunction,
): InvoiceFormReceiver => ({
  ...customer,
  name: t(tName),
})
